import React, { Component } from 'react';
import { Query, withApollo } from 'react-apollo';
import { Button, message, Table, Popconfirm, Tag, Select } from 'antd';
import {
  GET_WECHAT_GROUPS,
  CREATE_WECHAT_GROUP,
  UPDATE_WECHAT_GROUP,
  DELETE_WECHAT_GROUP,
} from '../../api/wechatgroup';
import './index.css';
import ModalBox from '../../components/ModalBox';
import Loading from '../../components/Loading';
import WechatGroupForm from './WechatGroupForm';

class WechatGroupList extends Component {
  state = {
    selectedGroup: null,
    modalVisible: false,
    formMode: null,
    selectedSchool: '全部',
  };

  toggleModal = (group) => {
    this.setState({
      modalVisible: !this.state.modalVisible,
      formMode: group ? 'update' : 'create',
      selectedGroup: group,
    });
  };

  onAddGroup = (groupData) => {
    this.props.client
      .mutate({
        mutation: CREATE_WECHAT_GROUP,
        variables: { data: groupData },
        refetchQueries: () => [{ 
          query: GET_WECHAT_GROUPS,
          variables: {
            pageSize: 15,
            currentPage: 1,
            searchTerm: this.state.selectedSchool === '全部' ? {} : { school: this.state.selectedSchool }
          }
        }],
      })
      .then(() => {
        message.success('微信群组创建成功!');
      })
      .catch((err) => message.error(err.message || '创建失败!'));
  };

  onEditGroup = (_id, groupData) => {
    this.props.client
      .mutate({
        mutation: UPDATE_WECHAT_GROUP,
        variables: { _id, data: groupData },
        refetchQueries: () => [{ 
          query: GET_WECHAT_GROUPS,
          variables: {
            pageSize: 15,
            currentPage: 1,
            searchTerm: this.state.selectedSchool === '全部' ? {} : { school: this.state.selectedSchool }
          }
        }],
      })
      .then(() => {
        message.success('微信群组更新成功!');
      })
      .catch((err) => message.error(err.message || '更新失败!'));
  };

  onDeleteGroup = (_id) => {
    this.props.client
      .mutate({
        mutation: DELETE_WECHAT_GROUP,
        variables: { _id },
        refetchQueries: () => [{ 
          query: GET_WECHAT_GROUPS,
          variables: {
            pageSize: 15,
            currentPage: 1,
            searchTerm: this.state.selectedSchool === '全部' ? {} : { school: this.state.selectedSchool }
          }
        }],
      })
      .then(() => message.success('微信群组删除成功!'))
      .catch((err) => message.error(err.message || '删除失败!'));
  };

  setRef = (ref) => {
    this.formRef = ref;
  };

  onGroupFormSubmit = () => {
    if (this.formRef) {
      const { selectedGroup, formMode } = this.state;
      this.formRef.props.form.validateFields((err, values) => {
        if (!err) {
          console.log('表单内容:', values);
          
          // 处理标签数据：将数组转换为逗号分隔的字符串
          const processedData = {
            ...values,
            tag: Array.isArray(values.tag) ? values.tag.join(',') : values.tag,
          };
          if (formMode === 'create') {
            this.onAddGroup(processedData);
          } else {
            this.onEditGroup(selectedGroup._id, processedData);
          }
          this.toggleModal(); // 关闭模态框
        }
      });
    }
  };

  handleSchoolChange = (value) => {
    this.setState({ selectedSchool: value });
  };

  render() {
    const { modalVisible, selectedGroup, formMode, selectedSchool } = this.state;
    const pageSize = 15;
    const currentPage = 1;
    const searchTerm = selectedSchool === '全部' ? {} : { school: selectedSchool };

    const columns = [
      {
          title: '群组名称',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '所属学校',
          dataIndex: 'school',
          key: 'school',
          width: 100,
        },
      {
        title: '标签',
        dataIndex: 'tag',
        key: 'tag',
        render: (tag) => {
          if (!tag) return '-';
          const tags = tag.split(',').map(t => t.trim()).filter(t => t);
          return (
            <div>
              {tags.map((tagItem, index) => (
                <Tag key={index} color="blue" style={{ marginBottom: 4 }}>
                  {tagItem}
                </Tag>
              ))}
            </div>
          );
        },
      },
      {
        title: '描述',
        dataIndex: 'desc',
        key: 'desc',
        width: 200,
        ellipsis: true,
      },
      {
        title: '群主',
        dataIndex: 'owner',
        key: 'owner',
      },
      {
        title: '二维码',
        dataIndex: 'qrCode',
        key: 'qrCode',
        render: (qrCode) => {
          if (!qrCode) return '-';
          return (
            <a 
              href={qrCode} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#1890ff' }}
            >
              查看二维码
            </a>
          );
        },
      },
      {
        title: '过期时间',
        dataIndex: 'expressDate',
        key: 'expressDate',
      },
      {
        title: '是否展示',
        dataIndex: 'isOnShow',
        key: 'isOnShow',
        render: (isOnShow) => (
          <Tag color={isOnShow ? 'green' : 'red'}>
            {isOnShow ? '展示' : '隐藏'}
          </Tag>
        ),
      },
      {
        title: '操作',
        key: 'action',
        render: (text, record) => (
          <div>
            <Button
              type="link"
              onClick={() => this.toggleModal(record)}
              style={{ marginRight: 8 }}
            >
              编辑
            </Button>
            <Popconfirm
              title="确定要删除这个微信群组吗？"
              onConfirm={() => this.onDeleteGroup(record._id)}
              okText="确定"
              cancelText="取消"
            >
              <Button type="link" style={{ color: '#ff4d4f' }}>
                删除
              </Button>
            </Popconfirm>
          </div>
        ),
      },
    ];

    return (
      <div className="wechat-group-list">
        <div className="header">
          <h2>微信群组管理</h2>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <Select
                value={selectedSchool}
                onChange={this.handleSchoolChange}
                style={{ width: 120 }}
                placeholder="选择学校"
              >
                <Select.Option value="全部">全部</Select.Option>
                <Select.Option value="XJTLU">XJTLU</Select.Option>
                <Select.Option value="XJTU">XJTU</Select.Option>
                <Select.Option value="其他">其他</Select.Option>
              </Select>
              <Button type="primary" onClick={() => this.toggleModal()}>
                添加群组
              </Button>
            </div>
        </div>

        <Query 
          query={GET_WECHAT_GROUPS}
          variables={{
            pageSize,
            currentPage,
            searchTerm
          }}
        >
          {({ loading, error, data }) => {
            if (loading) return <Loading />;
            if (error) return <p>Error: {error.message}</p>;

            return (
              <Table
                columns={columns}
                dataSource={data.wechatGroups}
                rowKey="_id"
                pagination={{
                  pageSize: 10,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  showTotal: (total, range) =>
                    `第 ${range[0]}-${range[1]} 条，共 ${total} 条`,
                }}
              />
            );
          }}
        </Query>

        <ModalBox
          title={formMode === 'create' ? '添加微信群组' : '编辑微信群组'}
          visible={modalVisible}
          onConfirm={this.onGroupFormSubmit}
          onCancel={() => this.toggleModal()}
        >
          <WechatGroupForm
            key={selectedGroup ? selectedGroup._id : 'create'}
            onSubmit={this.onGroupFormSubmit}
            onSetRef={this.setRef}
            group={selectedGroup}
          />
        </ModalBox>
      </div>
    );
  }
}

export default withApollo(WechatGroupList);